import { resolveDateTime } from '../relativeDates';
import { escXml } from './esc';

export interface Acmt023Input {
  assignmentId: string;
  vrfId: string;
  createdAt: string;
  assignorBic: string;
  assigneeBic: string;
  creditorName: string;
  creditorIban: string;
  xmlns: string;
  /** Document xmlns for the paired acmt.024 */
  pairXmlns: string;
  reportId: string;
  updatedName: string;
  reasonCode: string;
}

const created = new Date().toISOString().replace(/\.\d{3}Z$/, '');

export const DEFAULT_ACMT023_INPUT: Acmt023Input = {
  assignmentId: 'VOP-TRY-0001',
  vrfId: 'VRF-TRY-0001',
  createdAt: created,
  assignorBic: 'DEMOFRPPXXX',
  assigneeBic: 'COBADEFFXXX',
  creditorName: 'Atelier Rousseau SARL',
  creditorIban: 'DE89370400440532013000',
  xmlns: 'urn:iso:std:iso:20022:tech:xsd:acmt.023.001.04',
  pairXmlns: 'urn:iso:std:iso:20022:tech:xsd:acmt.024.001.04',
  reportId: 'VOPR-TRY-0001',
  updatedName: 'Atelier Rousseau S.A.R.L.',
  reasonCode: 'CMTC',
};

export function freshAcmt023Input(): Acmt023Input {
  return { ...DEFAULT_ACMT023_INPUT, createdAt: resolveDateTime('now') };
}

export function buildAcmt023(input: Acmt023Input): string {
  return `<?xml version="1.0" encoding="UTF-8"?>
<Document xmlns="${escXml(input.xmlns)}">
  <IdVrfctnReq>
    <Assgnmt>
      <MsgId>${escXml(input.assignmentId)}</MsgId>
      <CreDtTm>${escXml(input.createdAt)}</CreDtTm>
      <Assgnr><Agt><FinInstnId><BICFI>${escXml(input.assignorBic)}</BICFI></FinInstnId></Agt></Assgnr>
      <Assgne><Agt><FinInstnId><BICFI>${escXml(input.assigneeBic)}</BICFI></FinInstnId></Agt></Assgne>
    </Assgnmt>
    <Vrfctn>
      <Id>${escXml(input.vrfId)}</Id>
      <PtyAndAcctId>
        <Pty><Nm>${escXml(input.creditorName)}</Nm></Pty>
        <Acct><Id><IBAN>${escXml(input.creditorIban)}</IBAN></Id></Acct>
      </PtyAndAcctId>
    </Vrfctn>
  </IdVrfctnReq>
</Document>`;
}

export function buildAcmt024(input: Acmt023Input, outcome: string, _rejectReason: string): string {
  const verified = outcome === 'MTCH';
  const reportId = input.reportId.trim() || input.assignmentId.replace(/VOP/i, 'VOPR');
  const updatedBlock = verified
    ? ''
    : `<UpdtdPtyAndAcctId><Pty><Nm>${escXml(input.updatedName)}</Nm></Pty></UpdtdPtyAndAcctId>`;
  const reasonBlock = verified ? '' : `<Rsn><Cd>${escXml(input.reasonCode)}</Cd></Rsn>`;

  return `<?xml version="1.0" encoding="UTF-8"?>
<Document xmlns="${escXml(input.pairXmlns)}">
  <IdVrfctnRpt>
    <Assgnmt>
      <MsgId>${escXml(reportId)}</MsgId>
      <CreDtTm>${escXml(input.createdAt)}</CreDtTm>
      <Assgnr><Agt><FinInstnId><BICFI>${escXml(input.assigneeBic)}</BICFI></FinInstnId></Agt></Assgnr>
      <Assgne><Agt><FinInstnId><BICFI>${escXml(input.assignorBic)}</BICFI></FinInstnId></Agt></Assgne>
    </Assgnmt>
    <OrgnlAssgnmt><MsgId>${escXml(input.assignmentId)}</MsgId></OrgnlAssgnmt>
    <Rpt>
      <OrgnlId>${escXml(input.vrfId)}</OrgnlId>
      <Vrfctn>${verified ? 'true' : 'false'}</Vrfctn>
      ${reasonBlock}
      <OrgnlPtyAndAcctId>
        <Pty><Nm>${escXml(input.creditorName)}</Nm></Pty>
        <Acct><Id><IBAN>${escXml(input.creditorIban)}</IBAN></Id></Acct>
      </OrgnlPtyAndAcctId>
      ${updatedBlock}
    </Rpt>
  </IdVrfctnRpt>
</Document>`;
}
